"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedNFT = void 0;
var WrappedNFTAbi_json_1 = __importDefault(require("./WrappedNFTAbi.json"));
exports.WrappedNFT = WrappedNFTAbi_json_1.default;
